var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartMaximum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chart Maximum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6665 3C5.21879 3 5.6665 3.44772 5.6665 4V17C5.6665 18.1046 6.56193 19 7.6665 19H20.6665C21.2188 19 21.6665 19.4477 21.6665 20C21.6665 20.5523 21.2188 21 20.6665 21H7.6665C5.45737 21 3.6665 19.2091 3.6665 17V4C3.6665 3.44772 4.11422 3 4.6665 3Z",
    fill: "#8694A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6665 17C9.21879 17 9.6665 16.5523 9.6665 16C9.6665 13.0581 10.0376 10.2093 10.9021 8.13461C11.7616 6.07182 12.989 5 14.6665 5C16.344 5 17.5714 6.07182 18.4309 8.13461C19.2954 10.2093 19.6665 13.0581 19.6665 16C19.6665 16.5523 20.1142 17 20.6665 17C21.2188 17 21.6665 16.5523 21.6665 16C21.6665 12.9419 21.2876 9.79073 20.2771 7.36539C19.2616 4.92818 17.489 3 14.6665 3C11.844 3 10.0714 4.92818 9.05593 7.36538C8.04537 9.79073 7.6665 12.9419 7.6665 16C7.6665 16.5523 8.11422 17 8.6665 17Z",
    fill: "#8694A1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMaximum);
export default __webpack_public_path__ + "static/media/chart-maximum.2a8f961be784177d4c8b7015a77cc92a.svg";
export { ForwardRef as ReactComponent };